// Step Progress Component
// Visual progress indicator with circles connected by lines
// Used for multi-step processes like model import walkthrough

import React from 'react';
import './StepProgress.css';

export function StepProgress({
  steps = [],
  currentStep = 0,
  validatedSteps = [], // Array of step indices that have been validated
  onStepClick,
  linear = false, // If true, only allows clicking on completed steps
  className = '',
  ...props
}) {
  const handleStepClick = (stepIndex) => {
    if (!onStepClick) return;

    // Only allow clicking on validated steps
    if (!validatedSteps.includes(stepIndex)) {
      return;
    }

    onStepClick(stepIndex);
  };

  const isStepCompleted = (stepIndex) => validatedSteps.includes(stepIndex) && stepIndex !== currentStep;
  const isStepActive = (stepIndex) => stepIndex === currentStep;
  const isStepClickable = (stepIndex) => {
    if (!onStepClick) return false;
    return validatedSteps.includes(stepIndex);
  };

  return (
    <div className={`step-progress ${className}`} {...props}>
      <div className="step-progress-container">
        {steps.map((step, index) => {
          const isCompleted = isStepCompleted(index);
          const isActive = isStepActive(index);
          const isClickable = isStepClickable(index);
          const showConnector = index < steps.length - 1;

          return (
            <React.Fragment key={index}>
              {/* Step Circle */}
              <div
                className={`step-progress-step ${
                  isCompleted ? 'completed' :
                  isActive ? 'active' : 'pending'
                } ${isClickable ? 'clickable' : ''}`}
                onClick={() => handleStepClick(index)}
                role={isClickable ? 'button' : undefined}
                tabIndex={isClickable ? 0 : undefined}
                onKeyDown={(e) => {
                  if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    handleStepClick(index);
                  }
                }}
              >
                <div className="step-progress-circle">
                  {isCompleted ? (
                    <i className="fa-solid fa-check"></i>
                  ) : (
                    <span className="step-progress-number">{index + 1}</span>
                  )}
                </div>
                <div className="step-progress-label">
                  {step.label}
                </div>
              </div>

              {/* Connector Line */}
              {showConnector && (
                <div
                  className={`step-progress-connector ${
                    isCompleted ? 'completed' : 'pending'
                  }`}
                >
                  <div className="step-progress-line"></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}